import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { cancelFiletransfers } from 'console/redux/devices/items/actions';
import { Box, IconButton, LinearProgress, Typography } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { createSelector } from '@reduxjs/toolkit';
import { createSubsetSelector } from 'webui/utils/selectors';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { selectorSelectedDevice } from 'entities/device/lib';
export const firmware_types_titles = {
    firmware: 'Загрузка прошивки',
    firmware_extension: 'Загрузка прошивки для аксессуаров в устройство',
    soundpack: 'Загрузка звуков',
    fix_hw205_amr: 'Загрузка звуков',
    'log.txt': 'Загрузка лога',
    '': 'Загрузка файлов',
};
const select_device_filetransfers = createSelector(selectorSelectedDevice, createSubsetSelector(['filetransfers']));
export const FileTransfers = memo(function FileTransfers(props) {
    const { device_id } = props;
    const device = useAppSelector(select_device_filetransfers);
    const _onCancelFileTransfers = useAction(cancelFiletransfers);
    const onCancelFileTransfer = useCallback((transfer_id) => () => {
        _onCancelFileTransfers(device_id, { id: transfer_id });
    }, [device_id]);
    if (!device?.filetransfers || device.filetransfers.length === 0) {
        return null;
    }
    const { filetransfers } = device;
    const loading_filetransfers = filetransfers.filter((transfer) => !transfer.done);
    return (_jsx(Box, { bgcolor: "warning.main", children: loading_filetransfers.map((transfer) => {
            const title = firmware_types_titles[transfer.type] ?? firmware_types_titles[''];
            const percent = ~~(transfer.progress * 100);
            return (_jsxs(Box, { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", alignItems: "center", px: 2, py: 0.5, columnGap: 1, width: "100%", justifyItems: "flex-end", children: [_jsx(Typography, { color: "warning.contrastText", justifySelf: "flex-start", children: title }), _jsxs(Box, { display: "flex", alignItems: "center", width: "100%", maxWidth: 300, children: [_jsxs(Box, { width: "100%", position: "relative", children: [_jsx(LinearProgress, { variant: "determinate", color: "info", sx: { height: 14, borderRadius: 2 }, value: percent }), _jsxs(Typography, { color: "info.contrastText", position: "absolute", fontSize: "0.8rem", top: "50%", left: "50%", sx: {
                                            transform: 'translate3d(-50%, -50%, 0)',
                                        }, children: [percent, " %"] })] }), _jsx(IconButton, { onClick: onCancelFileTransfer(transfer.id), color: "error", children: _jsx(CloseRounded, { fontSize: "small" }) })] })] }, transfer.id));
        }) }));
});
